import React, { FC } from 'react';
import { formatDate } from 'utils/format';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AllAdditionalInfo } from 'models/order-input/shared';

type AdditionalCommentsProps = {
    additionalComments?: AllAdditionalInfo[];
};
const AdditionalComments: FC<AdditionalCommentsProps> = ({ additionalComments }) => {
    const { t: translate } = useTranslation(['orders']);

    if (!additionalComments?.length) {
        return null;
    }

    return (
        <Box>
            {additionalComments.map((comment, index) => (
                <Box key={index} mb={2}>
                    <Box>
                        <Typography variant="subtitle2">
                            {formatDate(new Date(comment.createdAt), 'datetime')} - {comment.updatedBy} (
                            {translate('orders:VERSION')} {comment.version})
                        </Typography>
                    </Box>
                    <Box
                        dangerouslySetInnerHTML={{
                            __html: (comment.additionalInfo || '')
                                // convert \n into <br/>
                                .replace(/\n/g, '<br/>'),
                        }}
                    />
                </Box>
            ))}
        </Box>
    );
};

export default AdditionalComments;
